import { render, staticRenderFns } from "./TaxOfficesList.vue?vue&type=template&id=526c1ca0"
import script from "./TaxOfficesList.vue?vue&type=script&lang=js"
export * from "./TaxOfficesList.vue?vue&type=script&lang=js"
import style0 from "./TaxOfficesList.vue?vue&type=style&index=0&id=526c1ca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports